/**
 * A person's initials for an avatar with no photo: the first letter of their first and last words, or
 * `?` for a blank name.
 *
 * ⚑ One copy for the console. The sidebar, the person peek and the account view each carried their
 * own, and a web's speakers would have been a fourth (ORB-946). `CompanyPeek` keeps its own on
 * purpose: a company's mark takes its first two words, not its first and last.
 *
 * Not `utils/initials.ts`: its `fullName` path gives one letter, where every console avatar shows two.
 */
export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  const first = parts[0][0] ?? ''
  const last = parts.length > 1 ? parts[parts.length - 1][0] : ''
  return (first + last).toUpperCase()
}
